import gql from "graphql-tag";

const REPROCESS_AUDIENCE = gql`
  query audienceRetargeting($id: ID) {
    audienceRetargeting(where: { id: $id })
  }
`;

export default REPROCESS_AUDIENCE;
